// ТЕКСТЫ ЭКРАНА ПАДЕНИЯ — три слота CD, строки Кирилла. Тикет `3eb19875cbb8814abba4f7502a55adbf`.
//
// ИСТОЧНИК БУКВЫ — решение `s945.d1` (Notion `3eb19875cbb8819fbaf4d2e0b2598739`, Кирилл 30.09).
// Перенос буква-в-букву, включая строчные и точки. Правка текста идёт в Notion, сюда приезжает
// следом — как у `submitCopy.js`.
//
// ⚠️ `wiz.error.action` — строчными и без стрелки: регистр и `→` даёт CSS, как у `continue`
// (`.wz-cta`). Экран — `StubScreen.jsx`, вид по борду Stub Screens v2 (тикет `3eb19875cbb881bb9a04e503ee488d31`).
//
// ⛔ `body` обещает «your answers are still here» — обещание держат автосейв на каждую смену
// конверта (`WizardProvider.jsx`) и запись имени этапа на каждое нажатие (`StepTwo.jsx`, `s945.d1`).
// Сети в продукте нет, поэтому строк вида «мы уже знаем» здесь нет и быть не может.

export const ERROR_COPY = {
  'wiz.error.title': 'this page stopped working.',
  'wiz.error.body': 'your answers are still here. reload to pick up where you left off.',
  'wiz.error.action': 'reload',
};
